import React from "react";

const faqs = [
  {
    question: "How old do I need to be to rent a car?",
    answer:
      "You can browse our selection online or contact us for assistance in choosing the right vehicle for you",
    defaultOpen: false,
  },
  {
    question: "What documents do I need to rent a car?",
    answer:
      "You can browse our selection online or contact us for assistance in choosing the right vehicle for you",
    defaultOpen: false,
  },
  {
    question: "What types of vehicles are available for rent?",
    answer:
      "You can browse our selection online or contact us for assistance in choosing the right vehicle for you",
    defaultOpen: true,
  },
  {
    question: "Can I rent a car with a debit card?",
    answer:
      "You can browse our selection online or contact us for assistance in choosing the right vehicle for you",
    defaultOpen: false,
  },
  {
    question: "What is your fuel policy?",
    answer:
      "You can browse our selection online or contact us for assistance in choosing the right vehicle for you",
    defaultOpen: false,
  },
  {
    question: "Can I add additional drivers to my rental agreement?",
    answer:
      "You can browse our selection online or contact us for assistance in choosing the right vehicle for you",
    defaultOpen: false,
  },
];

const FaqSection = () => {
  return (
    <section className="faq-section-four pt-0">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="section-heading heading-four" data-aos="fade-down">
              <h2>Frequently asked questions</h2>
              <p>Explore to learn more about how we can empower your business</p>
            </div>

            <div className="accordion faq-accordion" id="faqAccordion">
              {faqs.map((faq, index) => {
                const faqId = `faq${index + 1}`;
                return (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header" id={`heading${index + 1}`}>
                      <button
                        className={`accordion-button ${faq.defaultOpen ? "" : "collapsed"}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${faqId}`}
                        aria-expanded={faq.defaultOpen ? "true" : "false"}
                        aria-controls={faqId}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div
                      id={faqId}
                      className={`accordion-collapse collapse ${faq.defaultOpen ? "show" : ""}`}
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;